import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getHomepage } from 'api/Homepage';

export const fetchHomepage = createAsyncThunk(
    'fetchHomepage',
    async () => {
        const response = await getHomepage();
        return response.data;
    },
    {
        condition: (_, { getState }) => {
            const { homepage } = getState();
            if (homepage.data) return false;
        },
    },
);

const homepageSlice = createSlice({
    name: 'homepage',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchHomepage.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchHomepage.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchHomepage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default homepageSlice.reducer;
